'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('polygon', { points: '10.6274169 17.95991 27.9999996 17.95991 27.9999996 14.4400896 10.6274169 14.4400896 17.4648523 7.48888885 15.0166973 5 5.22407748 14.9555554 4 16.1999998 15.0166973 27.3999996 17.4648523 24.9111108 10.6274169 17.95991' })
  );
};

ArrowLeftIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = ArrowLeftIcon;